import { gql } from 'graphql-tag'
import {
  fragmentModuleMedia,
  fragmentModuleMediaCard,
  fragmentModuleNavigationLink
} from '#layers/core/data-layer/modules/fragments'
import queryPageFields from '#layers/core/data-layer/pages/page/query-page-fields'
import fragmentFinancialsFinancialRecap from '#layers/core/data-layer/financials/fragment-financials-financial-recap'

export default gql`
    ${fragmentModuleNavigationLink}
    ${fragmentModuleMedia}
    ${fragmentModuleMediaCard}
    ${fragmentFinancialsFinancialRecap}
    query($slug: String!, $locale: String!, $year: Int!, $preview: Boolean!) {
        page: pagePressAndMediaCollection(limit: 1, where: { slug: $slug }, locale: $locale, preview: $preview) {
            items {
                ${queryPageFields}
                headerPrimaryLink {
                    ...ModuleNavigationLinkFragment
                }
                headerSecondaryLink {
                    ...ModuleNavigationLinkFragment
                }
                newsroomLink {
                    ...ModuleNavigationLinkFragment
                }
                financialsTitle
                financialsEyebrow
                locationsTitle
                externalPressTitle
                externalPressItemsCollection {
                    items {
                        ...ModuleMediaCardFragment
                    }
                }
            }
        }
        newsCategories: pagePressAndMediaNewsroomCollection(limit: 1, locale: $locale, preview: $preview) {
            items {
                categoryCommercial
                categoryInvestorRelations
            }
        }
        news: pagePressAndMediaDetailCollection(where: { slug_exists: true, hiddenInHomePage_not: true }, order: date_DESC, limit: 3, locale: $locale, preview: $preview) {
            items {
                sys {
                    id
                }
                title
                date
                pressCategory
                city {
                    sys {
                        id
                    }
                    name
                }
                image {
                    ...ModuleMediaFragment
                }
            }
        }
        financialsHalfYear: financialsFinancialRecapCollection(where: { year_lte: $year, period_not_in: ["FY"] }, order: [year_DESC, period_DESC], limit: 5, preview: $preview) {
            items {
                ...on FinancialsFinancialRecap {
                    ...FinancialsFinancialRecapFragment
                }
            }
        }
        financialsFullYear: financialsFinancialRecapCollection(where: { year_lte: $year, period_in: ["FY"] }, order: [year_DESC, period_DESC], limit: 2, preview: $preview) {
            items {
                ...on FinancialsFinancialRecap {
                    ...FinancialsFinancialRecapFragment
                }
            }
        }
    }
`
